var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "error-license-lock",
        {
          attrs: {
            title: _vm.$t.__(
              "pages.errors.ErrorLicenseStaff.account_not_accessible"
            ),
            subtitles: [
              _vm.$t.__("pages.errors.ErrorLicenseStaff.no_licence_selected"),
              _vm.$t.__(
                "pages.errors.ErrorLicenseStaff.to_use_contact_company_admin"
              )
            ]
          }
        },
        [
          _c("CompassButton", {
            attrs: { label: _vm.labels.buttons.back_home, size: "large" },
            on: {
              click: function($event) {
                return _vm.goToUrl("https://go.sellsy.com")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }